import { useState } from "react";
import { RouteList } from "Routes";
import { useHistory } from "react-router-dom";

const storage = localStorage.getItem("Shitashi") ? sessionStorage : localStorage;

export const authTokenKey = "auth-v1";

const oldAuthTokenKeys = ["auth-token", "data-key", "token"];

for (const key of oldAuthTokenKeys) {
    storage.removeItem(key);
}

export const getToken = () => storage.getItem(authTokenKey) ?? "";
export const accessTokenFactory = () => getToken();

export const useAuth = () => {
    const history = useHistory();
    // initialize synchronously from storage so the first render accurately reflects auth state
    const [isAuthenticated, setIsAuthenticated] = useState(() => !!getToken());

    // account methods
    const login = (token: string) => {
        setIsAuthenticated(true);
        storage.setItem(authTokenKey, token);
        history.push(RouteList.Home);
    };

    const logout = () => {
        setIsAuthenticated(false);
        storage.removeItem(authTokenKey);
        history.push(RouteList.Home);
    };

    return {
        isAuthenticated,
        login,
        logout,
    };
};
